import React from 'react';
import { Typography, Card, Space } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const { Title, Text } = Typography;

const MessageCard = styled(Card)`
  background: var(--color-bg-secondary);
  border: 2px dashed var(--color-border-medium);
  border-radius: var(--radius-xl);
  text-align: center;
  padding: var(--spacing-4xl);
  margin: var(--spacing-4xl) 0;
  
  .ant-card-body {
    padding: var(--spacing-4xl);
  }
`;

const LockIcon = styled(LockOutlined)`
  font-size: 48px;
  color: var(--color-text-tertiary);
  margin-bottom: var(--spacing-xl);
`;

const MessageTitle = styled(Title)`
  color: var(--color-text-secondary);
  margin-bottom: var(--spacing-lg) !important;
`;

const MessageText = styled(Text)`
  color: var(--color-text-tertiary);
  font-size: 16px;
  line-height: 1.6;
`;

const PrivateCampaignMessage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <MessageCard bordered={false}>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <LockIcon />
        <MessageTitle level={3}>
          {t('#Campaign.private_campaign_locked')}
        </MessageTitle>
        <MessageText>
          {t('#Campaign.private_campaign_message')}
        </MessageText>
      </Space>
    </MessageCard>
  );
};

export default PrivateCampaignMessage;